import Http from '@/utils/http';
import { AppResponse, NoteItem, WordItem, QuestionExtraInfo, IQuestionListItem } from '@/types';

// 添加更新笔记
export const addUpdateNote = (params: {
    isSelf: number; // 1为隐私 0为公开（默认）
    noteContent: string; // 笔记内容		false
    noteId?: number; // 笔记ID 添加的时候不传，更新的时候传
    paperDataId?: number; //	对应 gd_paper_data 表主键id（记录ID）
    projectId: number; // 项目id
    questionId: number; // 题目id
    subjectId: number; // 科目ID
}): Promise<AppResponse<null>> => Http.post('/minerva/api/v1/front/note/save', params);

// 删除笔记
export const deleteNote = (noteId: number): Promise<AppResponse<null>> => Http.delete(`/minerva/api/v1/front/note/${noteId}`);

// 点赞或者取消点赞
export const addOrCancelNote = (params: {
    isFabulous: boolean; // true点赞 false取消点赞
    noteId: number; //	笔记ID
    projectId: number; // 项目id
    questionId: number; // 题目id
    subjectId: number; //	科目ID
}): Promise<AppResponse<null>> => Http.post(`/minerva/api/v1/front/note/fabulous`, params);

// 获取一个题目下的笔记列表
export const getNoteList = (params: { questionId: number }): Promise<AppResponse<NoteItem[]>> =>
    Http.get('/minerva/api/v1/front/note/question', params);

// 查询题目的附加信息
export const getQuestionExtraInfo = (params: {
    questionId: number; // 题目id
    dataTypeList: number[]; // 1 是否收藏 2 真题卷（来源）（按需要传入多个id）
    businessParam?: {};
}): Promise<AppResponse<QuestionExtraInfo>> => Http.post('/minerva/api/v1/front/question/extra', params);

// 收藏or取消
export const collectOrCancel = (params: {
    handleType: number; // 1-收藏；其他-取消收藏
    paperId?: number; // 试卷ID
    projectId: number; // 项目ID
    questionId: number; // 题目ID
    subjectId: number; // 科目ID
    questionIds?: number[]; // 批量取消使用
    businessParam?: {};
}): Promise<AppResponse<boolean>> => Http.post(`/minerva/api/v1/front/question-favorite/handle`, params);

// 题目 纠错
export const submitQuestionFeedback = (params: {
    projectId: number; // 项目id
    subjectId: number; // 科目id
    type: number; // 类型1错别字2答案有误3排版错误4图片模糊5答案有异议6其他错误9请求资源
    content: string; // 内容
    questionId: number; // 题目id
}) => Http.post('/minerva/api/v1/feedback/add', params);

// 当前题目下生词本
export const getUnknownWord = (params: { questionId: number }): Promise<AppResponse<WordItem[]>> =>
    Http.get('/minerva/api/v1/front/finance-word/match', params);

// 学员添加生词
export const addNewWordToList = (params: { wordId: number; projectId: number }): Promise<AppResponse<null>> =>
    Http.post('/minerva/api/v1/front/finance-word', params);

// 查询每个单词状态是否已经收藏
export const getWordStatus = (wordId: number, projectId: number): Promise<AppResponse<boolean>> =>
    Http.get(`/minerva/api/v1/front/finance-word/${wordId}?projectId=${projectId}`);

// 查询问答广场提问回答
export const getQuestionSquare = (data: {
    page: number; // 当前页码 从1开始
    ps: number; // 每页条数默认10
    project_id: number; //	项目id
    type: number; // 选填	类型：0：全部 1:为課程提问 2：题库 提问 3:bbs4：bbs微信端 5：财税学院6：glive
    resource_id: number; // 资源id
    resource_type: number; //	资源类型 1：视频 2：题目 3：课程 4：项目 、直播
    course_id?: number; // 课程id
}): Promise<
    AppResponse<
        {
            content: string; // 问题
            nick_name: string; // 昵称
            picture: string; // 头像
            id: number;
        }[]
    >
> => Http.get('/carefree/api/v1/front/ask/common', data);

/** 增加视频资源判断 是G1 还是G2 */
export const isG2OrG1VideoTask = (sourceId: string) => Http.get('/glive2-vod/api/v1/check/resource', { sourceId });

// 获取单题目详情
export const getSingleQuestionDetail = (id: number): Promise<AppResponse<IQuestionListItem>> =>
    Http.get(`/minerva/api/v1/front/question/info/${id}`);

// 根据题目项目科目id 获取 举一反三 paperDataLogId 新的 预测分抽题
export const getComprehendByAnalogyId = (params: {
    questionId: number; // 题目id
    projectId: number; // 项目id
    subjectId: number; // 科目id
    sourceFromType?: number;
    businessParam?: { [key: string]: any };
}): Promise<AppResponse<{ paperDataLogId: number; questionTotal: number }>> =>
    Http.post('/minerva/api/v1/front/predict-score/same/question/do-item', params);

// 老的举一反三抽题逻辑
export const getOldComprehendByAnalogyId = (params: {
    questionId: number; // 类型：Number  必有字段  备注：题目id
    sourceFromType: number; // 类型：Number  必有字段  备注：来源
    businessParam?: { [key: string]: any };
}): Promise<AppResponse<{ paperDataLogId: number; questionTotal: number }>> => Http.post('/minerva/api/v1/front/alike-exercise', params);
